import useSWR from "swr"

export const useNubeDocByOrderId = (id: string) => {
  const { data, error } = useSWR(`/orders/get-nube-data/${id}`);
  return {
    nubeDoc: data,
    isLoading: !error && !data,
    isError: error,
  }
}